export async function blobToBase64(blob: Blob): Promise<string> {
    if (typeof FileReader !== 'undefined') {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => {
                const result = reader.result as string
                resolve(result.split(',')[1])
            }
            reader.onerror = reject
            reader.readAsDataURL(blob)
        })
    }
    const arrayBuffer = await blob.arrayBuffer()
    const buffer = Buffer.from(arrayBuffer)
    return buffer.toString('base64')
}

export function base64ToBlob(
    base64: string,
    mimeType = 'application/pdf',
): Blob {
    // Convert base64url to standard base64 if needed
    // base64url uses '-' and '_' instead of '+' and '/', and no padding
    const standardBase64 = base64
        .replace(/-/g, '+')
        .replace(/_/g, '/')
        // Add padding if needed
        .padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')

    const binary = atob(standardBase64)
    const len = binary.length
    const bytes = new Uint8Array(len)
    for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i)
    }
    return new Blob([bytes], { type: mimeType })
}
